import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShieldCheckIcon, ServerIcon, SettingsIcon, InboxIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useDarkMode } from '../hooks/useDarkMode';
import { UserProfile } from './UserProfile';
interface LayoutProps {
  children: React.ReactNode;
}
const navItems = [{
  path: '/',
  label: 'Servers',
  icon: ServerIcon
}, {
  path: '/audit',
  label: 'Audit Inbox',
  icon: InboxIcon
}, {
  path: '/settings',
  label: 'Settings',
  icon: SettingsIcon
}];
export function Layout({
  children
}: LayoutProps) {
  const location = useLocation();
  const {
    isDark,
    toggle
  } = useDarkMode();
  return <div className="min-h-screen bg-slate-50 dark:bg-slate-950 transition-colors duration-200" data-id="element-41">
      {/* Top Navigation */}
      <header className="bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-800 transition-colors duration-200" data-id="element-42">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-43">
          <div className="flex items-center justify-between h-14" data-id="element-44">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-2" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/oMeYEvt4FAi4MGm33UZ8bU/MCPGuard-logo.png" alt="MCPGuard" className="h-32" data-id="element-46" />
            </Link>

            <div className="flex items-center gap-3" data-id="element-47">
              {/* Dark Mode Toggle */}
              <button onClick={toggle} className="p-2 text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-100 rounded-md hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors" aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-48">
                {isDark ? <SunIcon className="h-5 w-5" data-id="element-49" /> : <MoonIcon className="h-5 w-5" data-id="element-50" />}
              </button>

              {/* User Profile */}
              <UserProfile data-id="element-51" />

              {/* Navigation */}
              <nav className="flex items-center gap-1 ml-2 pl-3 border-l border-slate-200 dark:border-slate-800" data-id="element-52">
                {navItems.map(item => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path || item.path !== '/' && location.pathname.startsWith(item.path);
                return <Link key={item.path} to={item.path} className={`
                        flex items-center gap-2 px-3 py-2 text-sm font-medium rounded-md transition-colors
                        ${isActive ? 'bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-slate-100' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-slate-50 dark:hover:bg-slate-800/50'}
                      `} data-id="element-53">
                      <Icon className="h-4 w-4" data-id="element-54" />
                      {item.label}
                    </Link>;
              })}
              </nav>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-55">
        {children}
      </main>
    </div>;
}